<template>
    <div id="exportSetup" class="content">
                <h4>{{ title }}</h4>
                <hr>
                <div class="row">
                    <span style="margin-left: 15px">
                        <p>Select the fields to be included in the clock export file.</p>
                    </span>
                </div>
                <div class="row">
                    <div class="col-sm-11">
                        <form @submit.prevent="saveTemplate">
                            <div class="form-group row">
                                <table class="table">
                                    <thead class="thead-primary">
                                        <th v-for="item in tableHeader" :key="item.title">{{ item.title }}</th>
                                    </thead>
                                    <tr v-for="(item,index) in template" :key="index">
                                        <td width="1%">{{ item.row_no }}</td>
                                        <td width="20%">{{ item.row_name }}</td>
                                        <td style="text-align: center; width: 5%;" >
                                            <input :id="index" class="form-check-input" type="checkbox" name="required" true-value="1" false-value="0" v-model="template[index].required" @change="checkTime(template[index].row_no, template[index].required)">
                                        </td>
                                        <td style="width: 10%">
                                            <input type="number" size="3" min="1" max="100" class="form-control" :id="'seqno_' + index" name="sequence" v-model="template[index].sequence" v-if="template[index].required != 0" @change="checkSequence(template[index].sequence)"  required>
                                        </td>
                                        <td width="20%">
                                            <select class="form-control" value="DDMMYYYY" v-model="template[index].type_format" v-if="item.row_no === 3 && template[index].required != 0" required>
                                                <option value="DDMMYYYY">DDMMYYYY</option>
                                                <option value="MMDDYYYY">MMDDYYYY</option>
                                                <option value="YYYYMMDD">YYYYMMDD</option>
                                                <option value="DD-MM-YYYY" selected>DD-MM-YYYY</option>
                                                <option value="MM-DD-YYYY">MM-DD-YYYY</option>
                                                <option value="YYYY-MM-DD">YYYY-MM-DD</option>
                                            </select>

                                            <select class="form-control" value="HHMMSS" v-model="template[index].type_format" v-if="(item.row_no === 4 || item.row_no === 10) && template[index].required != 0" required>
                                                <option value="HHmmss">HHMMSS</option>
                                                <option value="hhmmss a">HHMMSS A</option>
                                                <option value="HH:mm:ss" selected>HH:MM:SS</option>
                                                <option value="hh:mm:ss a">HH:MM:SS A</option>
                                                <option value="HHmm">HHMM</option>
                                                <option value="hhmm a">HHMM A</option>
                                                <option value="HH:mm" selected>HH:MM</option>
                                                <option value="hh:mm a">HH:MM A</option>
                                                <option value="Hmm">HMM</option>
                                                <option value="hmm a">HMM A</option>
                                                <option value="H:mm" selected>H:MM</option>
                                                <option value="h:mm a">H:MM A</option>
                                            </select>
                                        </td>
                                        <td style="width: 10%">
                                            <input type="number" size="3" min="1" max="100" class="form-control" :id="'char_' + index" name="char" v-model="template[index].no_char" v-if="template[index].required != 0">
                                        </td>
                                        <td style="width: 10%">
                                            <input type="text" size="10" class="form-control" :id="'inOutInc_' + index" name="inOutInc" v-model="template[index].in_out_inc" v-if="template[index].row_no == 5 && template[index].required !=0">
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            <div class="form-group row">
                                <div class="col-sm-3" >
                                    <label class="control-label">{{ label.lbl_file_type }}</label>
                                </div>
                                <div class="col-sm-6">
                                    <select class="form-control" v-model="templateOptions.filetype" required>
                                        <option v-for="(item, index) in fileType" :key="index">{{ item }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-sm-3" >
                                    <label class="control-label">{{ label.lbl_delimeter }}</label>
                                </div>
                                <div class="col-sm-6">
                                    <select class="form-control" value="," v-model="templateOptions.delimeter" required>
                                        <option v-for="(item, index) in delimeterType" :key="index">{{ item }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-sm-3" >
                                    <label class="control-label">{{ label.lbl_name }}</label>
                                </div>
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" required id="name" name="name" v-model="templateOptions.name">
                                </div>
                            </div>

                            <div class="form-group row text-center">
                            <div class="col-sm-11">
                                <button type="submit" class="btn btn-primary" >SAVE</button>
                                <router-link :to="`/${$i18n.locale}/export/list`"><button class="btn btn-primary">CANCEL</button></router-link>
                            </div>
                        </div>
                        </form>
                    </div>
                </div>
    </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'

export default {
    data() {
        return {
            title: 'Export Template Setup',
            tableHeader: [
                {
                    title: 'NO'
                },
                {
                    title: 'COLUMN'
                },
                {
                    title: 'REQUIRED'
                },
                {
                    title: 'SEQUENCE'
                },
                {
                    title: 'FORMAT'
                },
                {
                    title: 'CHAR'
                },
                {
                    title: 'IN / OUT INDICATOR'
                }
            ],
            template: [
                {
                    row_no: 1,
                    row_name: 'Company',
                    required: 0,
                    sequence: null,
                    type_format: null,
                    no_char: null,
                    in_out_inc: null
                },
                {
                    row_no: 2,
                    row_name: 'Name',
                    required: 0,
                    sequence: null,
                    type_format: null,
                    no_char: null,
                    in_out_inc: null
                },
                {
                    row_no: 3,
                    row_name: 'Date',
                    required: 1,
                    sequence: null,
                    type_format: null,
                    char: null,
                    in_out_inc: null
                },
                {
                    row_no: 4,
                    row_name: 'Device Time',
                    required: 0,
                    sequence: null,
                    type_format: null,
                    no_char: null,
                    in_out_inc: null
                },
                {
                    row_no: 5,
                    row_name: 'Type In\/Out',
                    required: 1,
                    sequence: null,
                    type_format: null,
                    no_char: null,
                    in_out_inc: null
                },
                {
                    row_no: 6,
                    row_name: 'Reason',
                    required: 0,
                    sequence: null,
                    type_format: null,
                    no_char: null,
                    in_out_inc: null
                },
                {
                    row_no: 7,
                    row_name: 'Project',
                    required: 0,
                    sequence: null,
                    type_format: null,
                    no_char: null,
                    in_out_inc: null
                },
                {
                    row_no: 8,
                    row_name: 'Device ID',
                    required: 0,
                    sequence: null,
                    type_format: null,
                    no_char: null,
                    in_out_inc: null
                },
                {
                    row_no: 9,
                    row_name: 'ID',
                    required: 0,
                    sequence: null,
                    type_format: null,
                    no_char: null,
                    in_out_inc: null
                },
                {   
                    row_no: 10,
                    row_name: 'System Time',
                    required: 0,
                    sequence: null,
                    type_format: null,
                    no_char: null,
                    in_out_inc: null
                },

                {
                    row_no: 11,
                    row_name: 'Location Name',
                    required: 0,
                    sequence: null,
                    type_format: null,
                    no_char: null,
                    in_out_inc: null
                },
                {
                    row_no: 12,
                    row_name: 'Location Code',
                    required: 0,
                    sequence: null,
                    type_format: null,
                    no_char: null,
                    in_out_inc: null
                },
                    
            ],
            label: {
                lbl_file_type: 'Select export file format',
                lbl_delimeter: 'Delimeter',
                lbl_name: 'Export Template Name'
            },
            templateOptions: {
                filetype: null,
                delimeter: null,
                name: null
            },

            sequenceOK: false,

            fileType: ['txt', 'csv'],
            delimeterType: ['\,', '\|']
        }
    },

    methods: {
        checkSequence(sequenceNo) {
            let arr = []

            for (let i = 0; i < this.template.length; i++) {
                if (this.template[i].required !== 0 && this.template[i].sequence !== null) {
                    arr.push(this.template[i].sequence)
                }
            }

            if (arr.length > _.uniq(arr).length) {
                this.sequenceOK = false
                alert("Duplicate sequence not allowed")
            } else {
                this.sequenceOK = true
            }
        },

        checkTime(row_no, required) {
          if (row_no === 4 && required === '1') {
            const index = this.template.findIndex(obj => obj.row_no === 10);
            if (index !== -1) {
              this.template[index].required = 0;
            }
          }

          if (row_no === 10 && required === '1') {
            const index = this.template.findIndex(obj => obj.row_no === 4);
            if (index !== -1) {
              this.template[index].required = 0;
            }
          }
        },

        testIndicator() {
            for (let i = 0; i < this.template.length; i++) {
                if (this.template[i].row_no == 5) {
                    let incValue = this.template[i].inOutInc;

                    var incArray = incValue.split(',');

                    alert(incArray[1]);
                }
            }
        },

        postTemplate() {
            let vm = this
            let templateData = JSON.stringify(this.template)
            let route = '/' + this.$i18n.locale + '/export/verify'

            axios.post(this.$store.getters.rootAPI + '/export/setup', {
                name: vm.templateOptions.name,
                filetype: vm.templateOptions.filetype,
                delimeter: vm.templateOptions.delimeter,
                template: templateData
            })
            .then(function (response) {
                vm.status = response.data.status

                if(vm.status === 'success') {
                    vm.$router.push(route)
                }

                if (response.data.errors.length > 0) {
                    vm.validationMsg = response.data.errors[0].msg
                    alert('Validation error. ' + vm.validationMsg)
                }
            })
             .catch(function (error) {
                if(error.response) {
                    vm.status = error.response.data
                    alert('An error occured. ' + vm.status)
                }
            })

        },

        saveTemplate() {
            if (this.sequenceOK === true) {
                this.postTemplate()
            }
        }
    }
}
</script>

<style scoped>
    table {
        margin-left: 15;
    }

    th {
        background-color: blue;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/export/ExportSetup.vue